import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand */}
          <div className="footer-section footer-brand-section">
            <div className="footer-logo-row">
              <img
                src="/Untitled design (24).png"
                alt="Quirke Trophies"
                className="footer-logo-img"
              />
              <div className="footer-logo-text">
                <h3 className="footer-company-name">Quirke Trophies</h3>
                <p className="footer-tagline">Because Excellence Deserves Reward</p>
              </div>
            </div>
            <p className="footer-description">
              For over 50 years, we've been proud to share in the successes of our customers
              and help celebrate their achievements.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => navigate('/home')} className="footer-link">Home</button>
              </li>
              <li>
                <button onClick={() => navigate('/shop')} className="footer-link">Shop</button>
              </li>
              <li>
                <button onClick={() => navigate('/gallery')} className="footer-link">Gallery</button>
              </li>
              <li>
                <button onClick={() => navigate('/about')} className="footer-link">About Us</button>
              </li>
              <li>
                <button onClick={() => navigate('/contact')} className="footer-link">Contact</button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <span className="footer-contact-label">Phone</span>
                <a href="tel:0527430288" className="footer-contact-value">(052) 743 0288</a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-label">Email</span>
                <a href="mailto:quirketrophies@mail.com" className="footer-contact-value">quirketrophies@mail.com</a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-label">Address</span>
                <span className="footer-contact-value">Glengall House, the Square, Cahir</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-title">Our Services</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => navigate('/shop?category=Personalisation')} className="footer-link">Engraving</button>
              </li>
              <li>
                <button onClick={() => navigate('/shop')} className="footer-link">Custom Trophies</button>
              </li>
              <li>
                <button onClick={() => navigate('/shop')} className="footer-link">Medals &amp; Awards</button>
              </li>
              <li>
                <button onClick={() => navigate('/contact')} className="footer-link">Bulk Orders</button>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {new Date().getFullYear()} Quirke Trophies Ltd. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <button onClick={() => navigate('/privacy')} className="footer-bottom-link">Privacy Policy</button>
            <button onClick={() => navigate('/terms')} className="footer-bottom-link">Terms &amp; Conditions</button>
            <button onClick={() => navigate('/returns')} className="footer-bottom-link">Returns</button>
            <button onClick={() => navigate('/delete-account')} className="footer-bottom-link">Delete Account</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
